(() => {
  const section = document.getElementById(document.currentScript?.dataset.section);
  if (!section || section.dataset.kmOnesieDiscounts) return;
  section.dataset.kmOnesieDiscounts = 'true';
  let panel;
  let summary;
  let badge;
  let tiers;
  const update = () => {
    const matrix = section.querySelector('[data-customizer-size-quantities]');
    const pricing = section.querySelector('[data-km-pdp-quantity-pricing]');
    if (!matrix || !pricing) return;
    const config = JSON.parse(pricing.textContent);
    if (!config.eligible) return;
    if (!panel) {
      tiers = config.tiers.filter(tier => tier[1] > 0);
      panel = document.createElement('details');
      panel.className = 'km-onesie-discounts';
      const heading = document.createElement('summary');
      const copy = document.createElement('div');
      copy.className = 'km-onesie-discounts__copy';
      const title = document.createElement('strong');
      title.textContent = 'Quantity discounts';
      summary = document.createElement('span');
      copy.append(title, summary);
      const savings = document.createElement('div');
      savings.className = 'km-onesie-discounts__savings';
      badge = document.createElement('span');
      badge.className = 'km-onesie-discounts__badge';
      const automatic = document.createElement('span');
      automatic.className = 'km-onesie-discounts__automatic';
      automatic.textContent = 'Applied automatically in cart.';
      savings.append(badge, automatic);
      heading.append(copy, savings);
      const list = document.createElement('ul');
      tiers.forEach(([quantity, discount]) => {
        const item = document.createElement('li');
        item.textContent = `${quantity}+ · ${discount}% off`;
        list.append(item);
      });
      const note = document.createElement('p');
      note.textContent = 'Discount quantities apply per size and color.';
      panel.append(heading, list, note);
    }
    if (matrix.nextElementSibling !== panel) matrix.after(panel);
    const quantity = Math.max(0, ...Array.from(matrix.querySelectorAll('input')).map(input =>
      input.disabled ? 0 : Number(input.value) || 0
    ));
    const active = [...tiers].reverse().find(tier => quantity >= tier[0]);
    const next = tiers.find(tier => quantity < tier[0]);
    const text = active
      ? `${active[1]}% off${next ? ` · Next break: ${next[0]}+ for ${next[1]}% off` : ''}`
      : next ? `Next break: ${next[0]}+ · ${next[1]}% off` : '';
    if (summary.textContent !== text) summary.textContent = text;
    const badgeText = active ? `Save ${active[1]}%` : `Save at ${next?.[0] || tiers[0][0]}+`;
    if (badge.textContent !== badgeText) badge.textContent = badgeText;
  };
  new MutationObserver(update).observe(section, { childList: true, subtree: true });
  section.addEventListener('input', update);
  section.addEventListener('customizer:size-quantities-change', update);
  update();
})();
